import instance from "@/services/api";

export const projectTypeWarrantiesAPI = {
  async getList() {
    return await instance()
      .get("/handbook/project_types/warranties/read/")
      .then((res) => res?.data);
  },
  async update(project_type_id, body) {
    return await instance()
      .put("/handbook/project_types/warranties/upd/", {
        project_type_id,
        ...body,
      })
      .then((res) => res?.data);
  },
};
